import { render, staticRenderFns } from "./MostPopularTopic.vue?vue&type=template&id=126c53c0&"
import script from "./MostPopularTopic.vue?vue&type=script&lang=js&"
export * from "./MostPopularTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports